export const Work = 'work'
export const Calendar = 'calendar'
